import api from './api';

export const getAllRegionalUsers = async () => {
  return await api.get('/api/sports/regional-users');
};

export const getRegionalUser = async (id) => {
  return await api.get(`/api/sports/regional-users/${id}`);
};

export const createRegionalUser = async (data) => {
  return await api.post('/api/sports/regional-users', data);
};

export const updateRegionalUser = async (id, data) => {
  return await api.put(`/api/sports/regional-users/${id}`, data);
};

export const updateRegionalUserPassword = async (id, newPassword) => {
  return await api.put(`/api/sports/regional-users/${id}/password`, { newPassword });
};

export const deleteRegionalUser = async (id) => {
  return await api.delete(`/api/sports/regional-users/${id}`);
};

export const getUserRegions = async (id) => {
  return await api.get(`/api/sports/regional-users/${id}/regions`);
};

export const assignRegions = async (id, regionIds) => {
  return await api.post(`/api/sports/regional-users/${id}/regions`, { regionIds });
};

export const removeRegionAssignment = async (id, regionId) => {
  return await api.delete(`/api/sports/regional-users/${id}/regions/${regionId}`);
};

export const loginRegionalUser = async (username, password) => {
  return await api.post('/api/sports/regional-users/login', { username, password });
};
